export const ROOT_CONFIGURATION_KEYS = {
    sdk: 'sdk',
    orbit: 'orbit',
    webData: 'webData',
    webDataSegments: 'webData.segments'
};